<div class="page-wrapper" data-aos="fade-up">
  <app-header *ngIf="showHeaderFooter"></app-header>
  <router-outlet ngxUiLoaderBlurred [blur]="10"></router-outlet>
  <app-footer *ngIf="showHeaderFooter"></app-footer>
  <ngx-ui-loader></ngx-ui-loader>
</div>